import React from 'react';
import { FlexCol, BasicContainer, TextDynamic, FlexDynamic } from '@minecraft.atoms';
import { WindowWidthContext } from '@minecraft.utils';
import { Carousel } from '@minecraft.molecules';
import { grid } from '@minecraft.themes';
import Icon from '@minecraft.icon';
import { useTranslation } from '@blocs.i18n';

export const TRUSTED_BRANDS_ICONS = [
  'brand-hulu',
  'brand-netflix',
  'brand-prime',
  'brand-max',
  'brand-visa',
  'brand-nike',
  'brand-verizon',
  'brand-amazon',
  'brand-toyota',
];

export const InfiniteBrandSroller = React.memo(() => {
  const { t } = useTranslation();
  const isMobile = WindowWidthContext.useIsMobile();
  const { md } = grid.breakpoints;

  return (
    <FlexDynamic
      data-testid="infinite-brand-scroller-wrapper"
      w="full"
      justifyContent="start"
      alignItems="center"
      gap="3"
      mdProps={{ gap: '2', justifyContent: 'center' }}
    >
      <TextDynamic
        align="left"
        fontWeight="semibold"
        color="disabled"
        mdProps={{ align: 'center' }}
        as="h3"
        fontSize="bodyLarge"
      >
        {t('common:paywall.checkout.trustedBrands')}
      </TextDynamic>
      <BasicContainer w="full">
        <Carousel
          maxW={!isMobile ? 'full' : undefined}
          settings={{
            dots: false,
            infinite: true,
            speed: 5000,
            slidesToShow: 9,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            pauseOnHover: false,
            pauseOnFocus: false,
            arrows: false,
            responsive: [
              {
                breakpoint: parseInt(String(md), 10),
                settings: {
                  slidesToShow: 4,
                },
              },
            ],
          }}
        >
          {TRUSTED_BRANDS_ICONS.map((brand) => (
            <FlexCol key={brand} w="full" justifyContent="center" alignItems="center">
              <Icon name={brand} size="2xl" />
            </FlexCol>
          ))}
        </Carousel>
      </BasicContainer>
    </FlexDynamic>
  );
});
